import { Box, Flex, Text } from '@chakra-ui/react';
import PropTypes from 'prop-types';
import React from 'react';

const TierDetailRow = ({ isLast, icon, label, description }) => {
  return (
    <Flex textAlign="left" fontSize="0" marginBottom={isLast ? '' : '10px'}>
      <Text
        variant="hintIcon"
        className="member-center-profile__hint-text"
        as="span"
      >
        {icon}
      </Text>
      <Box flex="1" marginLeft="13px">
        <Text
          display="inline"
          marginRight="8px"
          variant="hint"
          className="member-center-profile__hint-text member-center-profile__member-reminder-title"
        >
          {label}
        </Text>
        <Text
          display="inline"
          variant="description"
          className="tier-detail-row-description member-center-profile__description-text"
        >
          {description}
        </Text>
      </Box>
    </Flex>
  );
};

TierDetailRow.propTypes = {
  isLast: PropTypes.bool,
  icon: PropTypes.node.isRequired,
  label: PropTypes.node.isRequired,
  description: PropTypes.node,
};

export default TierDetailRow;
